
(function() {
	'use strict';

	//$(document).ready(()=>{
	// wait until DOM is ready
	document.addEventListener('DOMContentLoaded', function(event){

		//wait until images, links, fonts, stylesheets, and js is loaded
 		window.addEventListener('load', function(e){

			const mediaQuery = window.matchMedia('(max-width: 1024px)');

			let scrolling = false,
				scrollPos = 0;

			function appContainerScrollListener() {

				if (mediaQuery.matches) {
					//return
				}

				if (!scrolling) {			

					window.requestAnimationFrame(function () {

						// NAVIGATION CONCERNS
						/* * /
						if ( $('#navigation').hasClass('menu--opened') ) {

							$('body').removeClass('scroll-down scroll-up');

						} else {
						/**/

							if (window.scrollY <= 50) {

								document.body.classList.remove('scroll-active');
								document.body.classList.remove('scroll-up');
								document.body.classList.remove('scroll-down');

								//return;

							} else {

								document.body.classList.add('scroll-active');

							}

							// detects new state and compares it with the new one
							if ((document.body.getBoundingClientRect()).top > scrollPos ) {

								if (window.scrollY > 50) {
									document.body.classList.add('scroll-up');
									document.body.classList.remove('scroll-down');
								}

							} else {
								document.body.classList.remove('scroll-up');
								document.body.classList.add('scroll-down');

							}
							// saves the new position for iteration.
							scrollPos = (document.body.getBoundingClientRect()).top;

						//}

						scrolling = false;

					});

					scrolling = true;

				} else {

					//console.log('NOT SCROLLING', mq_width_md, scrolling);

					document.body.classList.remove('scroll-active');

				}

			}

			if ( window.addEventListener ) {

				window.addEventListener( 'scroll', appContainerScrollListener );

			} else {

				window.attachEvent( 'onScroll', appContainerScrollListener);
			}

			console.info("navigation.js loaded");

		}, false);

	});

})();
